module.exports = __webpack_public_path__ + "static/media/puzzle-piece.7a3e3dc5.svg";